<template>
  <div class="row">
    <hotline-table></hotline-table>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script type="text/babel">
  import HotlineTable from './HotlineContent/HotlineTable'
  export default {
    name: "Hotline",

    components: {
      HotlineTable
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/Hotline.vue